import { Exclude, Expose } from "class-transformer";
import { IsBoolean, IsDefined, IsNumber, IsString } from "class-validator";

import { GField, GInputType } from "../graphql";

// duplicated in packages/legacy-enums/src/legacy/CardPreregistrationAdditionalData.ts:1
@GInputType("BrowserInfoFor3DS2Input")
@Exclude()
export class BrowserInfoFor3DS2 {
    @GField({ nullable: true })
    @IsString()
    @IsDefined()
    @Expose()
    acceptHeader?: string;

    @GField()
    @IsBoolean()
    @IsDefined()
    @Expose()
    javaEnabled: boolean;

    @GField()
    @IsString()
    @IsDefined()
    @Expose()
    language: string;

    @GField()
    @IsNumber()
    @IsDefined()
    @Expose()
    colorDepth: number;

    @GField()
    @IsNumber()
    @IsDefined()
    @Expose()
    screenHeight: number;

    @GField()
    @IsNumber()
    @IsDefined()
    @Expose()
    screenWidth: number;

    @GField()
    @IsString()
    @IsDefined()
    @Expose()
    timeZoneOffset: string;

    @GField({ nullable: true })
    @IsString()
    @IsDefined()
    @Expose()
    userAgent?: string;

    @GField()
    @IsBoolean()
    @IsDefined()
    @Expose()
    javascriptEnabled: boolean;
}
